import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLifeRing } from '@fortawesome/free-solid-svg-icons'
import { Divider } from 'antd'

import AppointmentsTable from './partials/AppointmentsTable'
import NewAppointmentModal from './partials/NewAppointmentModal'
import NewTicketModal from '../Tickets/partials/NewTicketModal'
import OrdersList from '../Orders/partials/OrdersList'
import ListTopBar from '../../components/ListTopBar'

import { getAppointments } from './services'
import { handleError, parsePagination } from '../../helpers'

export default function AppointmentsList() {
	const user = useSelector(state => state.auth.user)
	const [appointments, setAppointments] = useState(null)
	const [pagination, setPagination] = useState({page: 1, per_page: 5, total: 0})
	const [filterType, setFilterType] = useState('start_at')
	const [filterValue, setFilterValue] = useState('')
	const [filterScope, setFilterScope] = useState('not_canceled')
	const [showTicketsModal, setShowTicketsModal] = useState(false)
	const [showNewAppointmentModal, setShowNewAppointmentModal] = useState(false)
	const [reloadOrders, setReloadOrders] = useState(false)

	useEffect(() => {
		!appointments && getAppointments({
			...pagination,
			'filter[supplier_id]': user.id,
			[`filter[${filterType}]`]: filterValue,
			[filterScope ? `filter[${filterScope}]` : 'noscope']: 1,
			include: 'order,orderDetail,vehicleType,warehouse,warehouseDock,orderDetails',
			sort: '-start_at',
		})
			.then(res => {
				setAppointments(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ appointments, pagination, filterType, filterValue, user, filterScope ])
    
    return (
		<React.Fragment>
			<ListTopBar
				title="Gestión de Citas Materias Primas"
				subtitle="Gestión de citas de entrega de materias primas"
			>
				<Button 
                    color='warning' 
                    size="sm" 
                    className='mt-10' 
                    onClick={() => setShowTicketsModal(true)}
                >
					<FontAwesomeIcon icon={faLifeRing} className='mr-5' />
					Necesito soporte
				</Button>
			</ListTopBar>
			<Divider className='mt-15 mb-10' />
			<h6 className='mb-0'>Citas Agendadas</h6>
			<ListTopBar
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				filterScope={filterScope}
				setFilterScope={setFilterScope}
				reload={() => setAppointments(null)}
				options={[
					{ label: 'Buscar fecha de la cita', value: 'start_at' },
					{ label: 'Buscar orden de compra', value: 'order.sku' },
				]}
				scopes={[
					{ label: 'Citas No Canceladas', value: 'not_canceled' },
					{ label: 'Citas Pendientes', value: 'pending' },
					{ label: 'Citas Confirmadas', value: 'confirmed' },
					{ label: 'Citas Canceladas', value: 'canceled' },
					{ label: 'Citas Asistidas', value: 'attended' },
					{ label: 'Citas Completadas', value: 'completed' },
					{ label: 'Citas No Asistidas', value: 'unattended' },
				]}
				ctaText="Agendar Cita"
				handleCtaClick={() => setShowNewAppointmentModal(true)}
			/>
			<AppointmentsTable 
				appointments={appointments} 
				reload={() => setAppointments(null)} 
				reloadOrders={() => setReloadOrders(true)}
				pagination={pagination} 
				setPagination={setPagination} 
			/>
			<Divider className='mt-15 mb-10' />
			<h6 className='mb-0'>Ordenes de compra</h6>
			<OrdersList 
				reloadOrders={reloadOrders}
				setReloadOrders={setReloadOrders}
			/>
			{ showTicketsModal && (
				<NewTicketModal
					visible
					onClose={() => setShowTicketsModal(false)}
					scope="appointments"
				/>
			)}
			{ showNewAppointmentModal && (
				<NewAppointmentModal
					visible
					onClose={() => setShowNewAppointmentModal(false)}
					reload={() => {
						setAppointments(null)
						setReloadOrders(true)
					}}
				/>
			)}
		</React.Fragment>
	)
}